import React from 'react';
import { Link } from 'react-router-dom';
import { ArrowLeft, CreditCard, FileText, Scale } from 'lucide-react';
import { Button } from '../../components/ui/button';

const TerminosVentaPage = () => {
  return (
    <div className="min-h-screen bg-zinc-950 text-zinc-300">
      <div className="max-w-4xl mx-auto px-4 py-8">
        <Link to="/">
          <Button variant="ghost" className="mb-6 text-zinc-400 hover:text-white">
            <ArrowLeft className="h-4 w-4 mr-2" />
            Volver
          </Button>
        </Link>

        <h1 className="text-3xl font-bold text-white mb-2">Términos y Condiciones de Venta de Servicios</h1>
        <p className="text-sm text-zinc-500 mb-8">Última actualización: 19 de febrero de 2026</p>

        <div className="mb-8 p-4 bg-zinc-900/50 rounded-lg">
          <h3 className="font-semibold text-zinc-200 mb-2">Titular del servicio</h3>
          <ul className="list-none space-y-1 text-sm">
            <li><strong className="text-zinc-400">Nombre:</strong> Jesús María Aguado Bonill</li>
            <li><strong className="text-zinc-400">NIF:</strong> 45300927N</li>
            <li><strong className="text-zinc-400">Domicilio:</strong> Avenida de España 3, 51001 Ceuta (España)</li>
            <li><strong className="text-zinc-400">Email:</strong> jagubon@icloud.com</li>
            <li><strong className="text-zinc-400">Dominios:</strong> guardiansfit.com | app.guardiansfit.com</li>
          </ul>
        </div>

        <div className="prose prose-invert prose-zinc max-w-none space-y-8">
          
          <section>
            <h2 className="text-xl font-semibold text-white border-b border-zinc-800 pb-2 mb-4">
              1. Objeto
            </h2>
            <p>
              Los presentes Términos y Condiciones de Venta regulan la contratación de los servicios digitales 
              de GUARDIÁNSFIT ofrecidos a través de la web y la plataforma (PWA y futura app móvil), consistentes 
              en planes de entrenamiento, seguimiento físico-conductual y servicios relacionados de fitness y 
              hábitos saludables.
            </p>
            <p className="mt-4">
              El contrato es un contrato de prestación de servicios a distancia entre GUARDIÁNSFIT y el cliente, 
              de acuerdo con la normativa de consumidores y usuarios española.
            </p>
          </section>

          <section>
            <h2 className="text-xl font-semibold text-white border-b border-zinc-800 pb-2 mb-4">
              2. Perfil del Cliente y Mayoría de Edad
            </h2>
            <p>Solo podrán contratar los servicios:</p>
            <ul className="list-disc pl-6 space-y-2 mt-4">
              <li>Personas físicas mayores de 18 años.</li>
              <li>Consumidores o usuarios finales (no es una plataforma de venta B2B, salvo acuerdos específicos con centros deportivos).</li>
            </ul>
            <div className="mt-4 p-4 bg-primary/10 border border-primary/20 rounded-lg">
              <p className="text-primary text-sm">
                Al contratar, el Cliente declara ser mayor de edad y tener capacidad legal para celebrar contratos.
              </p>
            </div>
          </section>

          <section>
            <h2 className="text-xl font-semibold text-white border-b border-zinc-800 pb-2 mb-4">
              3. Descripción de los Servicios
            </h2>
            <p>GUARDIÁNSFIT ofrece, entre otros, los siguientes tipos de servicios:</p>
            <div className="mt-4 grid gap-3">
              <div className="p-3 bg-zinc-900/50 rounded-lg flex items-center gap-3">
                <div className="w-2 h-2 rounded-full bg-primary"></div>
                <span>Acceso a la plataforma digital de planificación y seguimiento de entrenamientos.</span>
              </div>
              <div className="p-3 bg-zinc-900/50 rounded-lg flex items-center gap-3">
                <div className="w-2 h-2 rounded-full bg-primary"></div>
                <span>Planes de entrenamiento personalizados o semipersonalizados.</span>
              </div>
              <div className="p-3 bg-zinc-900/50 rounded-lg flex items-center gap-3">
                <div className="w-2 h-2 rounded-full bg-primary"></div>
                <span>Herramientas de registro de métricas físicas y de hábitos.</span>
              </div>
              <div className="p-3 bg-zinc-900/50 rounded-lg flex items-center gap-3">
                <div className="w-2 h-2 rounded-full bg-primary"></div>
                <span>Servicios de seguimiento por parte de entrenadores (cuando se contrate).</span>
              </div>
            </div>
            <p className="mt-4 text-sm text-zinc-400">
              La descripción concreta, precio, duración, características y condiciones de cada servicio se 
              muestran de forma clara en la web antes de la contratación.
            </p>
          </section>

          <section>
            <h2 className="text-xl font-semibold text-white border-b border-zinc-800 pb-2 mb-4">
              4. Naturaleza del Servicio
            </h2>
            <div className="p-4 bg-amber-900/20 border border-amber-800/30 rounded-lg">
              <div className="flex items-center gap-2 mb-2">
                <Scale className="h-5 w-5 text-amber-400" />
                <p className="font-semibold text-amber-300">Contrato de medios, no de resultado</p>
              </div>
              <p className="text-sm text-zinc-300">
                El Cliente reconoce y acepta que el contrato es de medios y no de resultado: GUARDIÁNSFIT y, 
                en su caso, los entrenadores se comprometen a poner medios razonables y profesionales para 
                ayudar al Cliente en su progreso, pero no garantizan un resultado concreto (pérdida de peso, 
                mejora de marcas, etc.).
              </p>
            </div>
          </section>

          <section>
            <h2 className="text-xl font-semibold text-white border-b border-zinc-800 pb-2 mb-4">
              5. Procedimiento de Contratación
            </h2>
            <ol className="list-decimal pl-6 space-y-3 mt-4">
              <li>El Cliente selecciona el servicio o plan deseado en la web o en la plataforma.</li>
              <li>Se muestra un resumen del servicio: precio, impuestos, duración, características y términos principales.</li>
              <li>El Cliente debe facilitar los datos requeridos (identificación y pago).</li>
              <li>Antes del pago, el Cliente deberá aceptar expresamente estos Términos y Condiciones de Venta y la Política de Privacidad.</li>
              <li>El contrato se entiende perfeccionado cuando el pago ha sido correctamente procesado y GUARDIÁNSFIT confirme la contratación.</li>
            </ol>
            <p className="mt-4 text-sm text-zinc-400">
              La lengua de contratación será el castellano, salvo indicación expresa de disponibilidad en otros idiomas.
            </p>
          </section>

          <section>
            <h2 className="text-xl font-semibold text-white border-b border-zinc-800 pb-2 mb-4">
              <div className="flex items-center gap-2">
                <CreditCard className="h-5 w-5" />
                6. Precio y Forma de Pago
              </div>
            </h2>
            <ul className="list-disc pl-6 space-y-2 mt-4">
              <li>Los precios de los servicios se indican en euros (€) e incluyen los impuestos aplicables, salvo indicación en contrario.</li>
              <li>El precio vigente será el que aparezca en la ficha del servicio en el momento de la contratación.</li>
              <li>El pago se realiza mediante los medios habilitados en la plataforma (por ejemplo, tarjeta bancaria a través de pasarela segura).</li>
              <li>En el caso de servicios de suscripción periódica, el cargo se realizará entre los días 1 y 8 de cada mes (u otro periodo equivalente indicado en la ficha del servicio).</li>
              <li>El acceso al servicio se activará una vez confirmado el pago. En caso de fallo de pago o devolución, GUARDIÁNSFIT podrá suspender el servicio hasta la regularización de la situación.</li>
            </ul>
          </section>

          <section>
            <h2 className="text-xl font-semibold text-white border-b border-zinc-800 pb-2 mb-4">
              7. Servicios de Suscripción y Renovaciones
            </h2>
            <p>
              Algunos servicios se ofrecen bajo la modalidad de suscripción periódica (mensual, trimestral, anual, etc.). En estos casos:
            </p>
            <ul className="list-disc pl-6 space-y-2 mt-4">
              <li>La suscripción se renovará automáticamente por periodos iguales, salvo cancelación por parte del Cliente.</li>
              <li>El Cliente puede gestionar o cancelar su suscripción desde su cuenta o contactando con soporte con un plazo razonable antes de la renovación.</li>
              <li>La falta de pago o impago reiterado podrá dar lugar al bloqueo de la cuenta, conforme a la cláusula específica de bloqueo.</li>
            </ul>
            <p className="mt-4 text-sm text-zinc-400">
              Los cambios de precio se comunicarán con antelación razonable y nunca se aplicarán con carácter 
              retroactivo sobre periodos ya abonados.
            </p>
          </section>

          <section>
            <h2 className="text-xl font-semibold text-white border-b border-zinc-800 pb-2 mb-4">
              <div className="flex items-center gap-2">
                <FileText className="h-5 w-5" />
                8. Derecho de Desistimiento
              </div>
            </h2>
            <p>
              En los servicios digitales personalizados y de acceso inmediato, el derecho de desistimiento 
              puede verse limitado conforme a la normativa de consumo:
            </p>
            <ul className="list-disc pl-6 space-y-2 mt-4">
              <li>Si el servicio comienza a ejecutarse con el consentimiento expreso del Cliente y este reconoce que pierde el derecho de desistimiento al iniciar la ejecución, podrá no ser aplicable el desistimiento de 14 días.</li>
              <li>En otros servicios estandarizados o no iniciados, el Cliente tendrá derecho de desistimiento en los plazos y condiciones previstos en la normativa de consumidores, en tanto resulte aplicable.</li>
            </ul>
          </section>

          <section>
            <h2 className="text-xl font-semibold text-white border-b border-zinc-800 pb-2 mb-4">
              9. Obligaciones del Cliente
            </h2>
            <p>El Cliente se compromete a:</p>
            <ul className="list-disc pl-6 space-y-2 mt-4">
              <li>Facilitar datos veraces, completos y actualizados durante el proceso de contratación y uso del servicio.</li>
              <li>No compartir sus credenciales de acceso con terceros no autorizados.</li>
              <li>Utilizar el servicio de manera diligente y conforme a la normativa aplicable y a los términos de GUARDIÁNSFIT.</li>
              <li>No manipular métricas ni datos con el fin de obtener ventajas indebidas (por ejemplo, en rankings, retos o resultados internos).</li>
            </ul>
            <p className="mt-4 text-sm text-zinc-400">
              El incumplimiento de estas obligaciones puede dar lugar a la suspensión o resolución del contrato, 
              conforme a la cláusula de bloqueo de cuenta.
            </p>
          </section>

          <section>
            <h2 className="text-xl font-semibold text-white border-b border-zinc-800 pb-2 mb-4">
              10. Obligaciones de GUARDIÁNSFIT
            </h2>
            <p>GUARDIÁNSFIT se compromete a:</p>
            <ul className="list-disc pl-6 space-y-2 mt-4">
              <li>Prestar los servicios contratados conforme a la descripción ofrecida en la web/plataforma.</li>
              <li>Mantener la plataforma operativa, con las interrupciones razonables por mantenimiento o causas técnicas.</li>
              <li>Atender las incidencias y consultas del Cliente en un plazo razonable, a través de los canales de contacto habilitados.</li>
              <li>Cumplir con la normativa de protección de datos y de consumidores y usuarios.</li>
            </ul>
          </section>

          <section>
            <h2 className="text-xl font-semibold text-white border-b border-zinc-800 pb-2 mb-4">
              11. Responsabilidad
            </h2>
            <p>
              El Cliente es responsable de su estado de salud y de consultar a un profesional médico antes 
              de iniciar cualquier programa de entrenamiento o cambio relevante de hábitos.
            </p>
            <p className="mt-4">GUARDIÁNSFIT no se responsabiliza de:</p>
            <ul className="list-disc pl-6 space-y-2 mt-4">
              <li>Lesiones o daños derivados de la práctica de ejercicio físico o del uso inadecuado de las recomendaciones de la plataforma.</li>
              <li>Resultados no alcanzados, dado que el contrato es de medios y no de resultado.</li>
              <li>Consecuencias derivadas de información falsa o incompleta facilitada por el Cliente.</li>
            </ul>
            <p className="mt-4 text-sm text-zinc-400">
              Esta cláusula se complementa con la Cláusula de Exención de Responsabilidad Deportiva incluida 
              en los textos legales generales de la plataforma.
            </p>
          </section>

          <section>
            <h2 className="text-xl font-semibold text-white border-b border-zinc-800 pb-2 mb-4">
              12. Cancelación, Reembolsos y Resolución
            </h2>
            <ul className="list-disc pl-6 space-y-2 mt-4">
              <li>El Cliente puede cancelar su suscripción para evitar futuras renovaciones, pero la cancelación no implica, salvo que se indique expresamente, la devolución de importes ya abonados por periodos consumidos o en curso.</li>
              <li>GUARDIÁNSFIT podrá resolver el contrato y suspender el acceso al servicio en caso de impago, fraude o incumplimiento grave de las obligaciones del Cliente.</li>
              <li>En caso de resolución anticipada imputable a GUARDIÁNSFIT, se valorará la devolución proporcional de las cantidades abonadas por servicios no prestados, de acuerdo con la normativa de consumidores.</li>
            </ul>
          </section>

          <section>
            <h2 className="text-xl font-semibold text-white border-b border-zinc-800 pb-2 mb-4">
              13. Protección de Datos
            </h2>
            <p>
              El tratamiento de los datos personales del Cliente en el marco de la contratación de servicios 
              se regirá por la Política de Privacidad de GUARDIÁNSFIT, que forma parte integrante de estos 
              Términos y Condiciones de Venta.
            </p>
            <p className="mt-4">
              El Cliente declara haber leído y aceptado la Política de Privacidad antes de finalizar el proceso de compra.
            </p>
          </section>

          <section>
            <h2 className="text-xl font-semibold text-white border-b border-zinc-800 pb-2 mb-4">
              14. Modificación de las Condiciones
            </h2>
            <p>
              GUARDIÁNSFIT se reserva el derecho a actualizar o modificar los presentes Términos y Condiciones 
              de Venta, siempre que:
            </p>
            <ul className="list-disc pl-6 space-y-2 mt-4">
              <li>Las modificaciones se publiquen de forma visible en la web.</li>
              <li>No afecten a las condiciones de contratos ya perfeccionados, salvo que cuenten con el consentimiento del Cliente o vengan impuestas por norma legal.</li>
            </ul>
            <p className="mt-4 text-sm text-zinc-400">
              Las nuevas condiciones serán aplicables a contrataciones realizadas tras su entrada en vigor.
            </p>
          </section>

          <section>
            <h2 className="text-xl font-semibold text-white border-b border-zinc-800 pb-2 mb-4">
              15. Ley Aplicable y Jurisdicción
            </h2>
            <p>
              Estos Términos y Condiciones de Venta se regirán e interpretarán de conformidad con las leyes 
              de España, en particular por la normativa de consumidores y usuarios.
            </p>
            <p className="mt-4">
              Salvo derechos irrenunciables del consumidor, las partes se someten a los Juzgados y Tribunales 
              de Ceuta para la resolución de cualquier controversia derivada de la contratación de los servicios.
            </p>
          </section>

        </div>

        <div className="mt-12 pt-8 border-t border-zinc-800">
          <p className="text-sm text-zinc-500 text-center">
            © 2026 GUARDIÁNSFIT - Todos los derechos reservados
          </p>
        </div>
      </div>
    </div>
  );
};

export default TerminosVentaPage;
